(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var toggle = document.querySelector('[data-il-mobile-toggle]');
    var nav = document.querySelector('[data-il-nav]');
    if(toggle && nav){
      toggle.addEventListener('click', function(){
        nav.classList.toggle('is-open');
      });
    }

    // Keep the header cart count in sync when other sections dispatch cart updates
    document.addEventListener('cart:update', function(e){
      var countEls = document.querySelectorAll('[data-il-cart-count]');
      if(e.detail && typeof e.detail.item_count !== 'undefined'){
        countEls.forEach(function(el){ el.textContent = e.detail.item_count; });
      }
    });

    // subtle site-wide cursor sparkle trail
    if(document.body.dataset.cursorTrail !== 'false'){
      var lastSpawn = 0;
      document.addEventListener('mousemove', function(e){
        var now = Date.now();
        if(now - lastSpawn < 70) return;
        lastSpawn = now;
        var dot = document.createElement('div');
        dot.className = 'il-trail-dot';
        dot.style.left = e.clientX + 'px';
        dot.style.top = e.clientY + 'px';
        document.body.appendChild(dot);
        setTimeout(function(){ dot.remove(); }, 700);
      });
    }
  });
})();
